import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Conversaciones más cortas, más claras', 'Menos discusiones repetidas por tonterías', 'Más cooperación práctica (aunque sea mínima)', 'Más paz mental después de hablar (adiós culpa)', 'Un plan de 7 días para implementarlo paso a paso'];
  return <Section background="white" data-id="element-28">
      <div className="text-center max-w-3xl mx-auto mb-6" data-id="element-29">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-stone-900" data-id="element-30">
          Qué vas a lograr
        </h2>
        <p className="text-stone-500 mt-2 text-sm" data-id="element-31">
          Resultados reales, no ideales inalcanzables.
        </p>
      </div>

      <div className="grid gap-3 max-w-2xl mx-auto" data-id="element-32">
        {benefits.map((benefit, i) => <div key={i} className="flex items-center gap-3 p-3 bg-stone-50 rounded-xl border border-stone-100 transition-all hover:border-orange-200 hover:bg-orange-50/30" data-id="element-33">
            <div className="h-7 w-7 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-34">
              <Check className="w-4 h-4 text-green-700" data-id="element-35" />
            </div>
            <span className="text-base text-stone-800 font-medium" data-id="element-36">
              {benefit}
            </span>
          </div>)}
      </div>
    </Section>;
}